import { memo } from 'react';

import { RichText } from '#/components/Text/RichText';
import type { CmsApiRichTextBlockData } from '#/modules/cms/api/types/blocks/CmsApiRichTextBlock';

type Props = {
  blockIndex: number;
  data: CmsApiRichTextBlockData;
};

/**
 * RICHTEXT blocks use useLinksHaveUTMParams which adds UTM params to external
 * links after mount. We use memo to prevent losing them when re-rendering.
 */
export const CmsRichTextBlock = memo(
  function CmsRichTextBlock({ blockIndex, data: { html } }: Props) {
    return (
      <RichText
        dangerouslySetInnerHTML={{
          __html: html,
        }}
        analyticsData={{
          eventName: 'CMS Block',
          eventProperties: {
            block_position: blockIndex,
            block_type: 'Rich Text',
          },
        }}
      />
    );
  },
  // Always return true = never re-render after initial mount
  () => true,
);
